const customerSay = [
  {
    img: "https://media.istockphoto.com/photos/smiling-indian-man-looking-at-camera-picture-id1270067126?k=20&m=1270067126&s=612x612&w=0&h=ZMo10u07vCX6EWJbVp27c7jnnXM2z-VXLd-4maGePqc=",
    title: "One of the best e-commerce shope!",
    description:
      "I literally spent most of my afternoon trying to figure something out on my computer and after giving up in frustration, I called a random number which, (lucky me) was Refresh Computers. In less than 3 minutes a very helpful assistant had talked me through the problem and I was good to go!!! I’m not very techy but he was super patient and willing to help.",
    name: "Anna Mary Smucker",
    ratings: 5,
  },
  {
    img: "https://freepngimg.com/thumb/man/22654-6-man.png",
    title: "Just amaizing services!",
    description:
      "I brought my laptop there which is only about 4 years old. I thought it was beyond repair. They diagnosed it for free and gave me a fair price and an ETA of 3 to 5 business days. I dropped it off the day before Thanksgiving and the day after Thanksgiving I received a text saying my computer was ready for pickup. They replaced my hard drive with a solid state and restored all of my drivers and the operating system. My laptop runs better than the day I bought it. Thank you guys so much!!",
    name: "Jennifer Martz,",
    ratings: 5,
  },

  {
    img: "https://www.pngall.com/wp-content/uploads/2016/05/Man-Download-PNG.png",
    title: "Great services!",
    description:
      "Definitely five star customer service would highly recommend this company. They even went out of the way to deliver my sons laptop to my house couldn’t be more thankful.",
    name: "Alex Prince",
    ratings: 4,
  },
  {
    img: "https://pngimage.net/wp-content/uploads/2018/06/guy-png-4.png",
    title: "Very good services!",
    description:
      "Had a problem with my computer and brought it in to be fixed not know what it was going to take. They fixed free, while I waited. That’s how to build a customer for life.",
    name: "David J",
    ratings: 4.5,
  },

  {
    img: "https://i.insider.com/5dcc135ce94e86714253af21?width=1000&format=jpeg&auto=webp",
    title: "Very impressive services!!",
    description:
      "Words cannot describe how appreciative I am of these guys over at Refresh, they transferred all of my PC components to a new case whilst installing several new parts I had bought. 0 Issues, all beautiful professional work and I am a very happy customer, will be returning with any future work needed, thank you guys.",
    name: "Bill Keevan",
    ratings: 5,
  },
  {
    img: "https://s.abcnews.com/images/GMA/paul-rudd-gty-jc-211111_1636673690293_mn_4x3_608.jpg",
    title: "Awesome services!!",
    description:
      "Doug was spectacular. A quick diagnosis and resolution. I recommend this place for all my computer repair, service and buying refurbished equipment… if you’re into that sort of thing.",
    name: "Kyle Schwarting",
    ratings: 4,
  },
];
export default customerSay;
